import { SourceDetail } from 'v2/core/entities/feedback/sources';
import { SourceName } from 'v2/core/entities/fields';
import { Timezone, User } from 'v2/core/entities/user';
import { UUID } from 'v2/core/entities/uuid';
import useGetSourceDetailsMap from 'v2/core/repository/edge-server/source-details';
import { Response } from 'v2/core/services/types';
import { useGetUser } from 'v2/core/services/user';

interface DashboardDeps {
  user: User;
  tenantID: UUID;
  timezone: Timezone;
  taxonomyID?: UUID;
  sourceDetailsMap?: Map<SourceName, SourceDetail>;
}

interface DashboardDepsResponse extends Response<DashboardDeps> {
  data: DashboardDeps;
}

const useGetDashboardDeps = (): DashboardDepsResponse => {
  const user = useGetUser();

  const {
    data: sourceDetailsMap,
    status: sStatus,
    error: sError,
  } = useGetSourceDetailsMap();

  return {
    data: {
      user,
      tenantID: user.tenant.id,
      timezone: user.tenant.timezone,
      sourceDetailsMap,
    },
    status: sStatus,
    error: sError,
  };
};

export default useGetDashboardDeps;
